import { jsx as _jsx } from "react/jsx-runtime";
import { extractCriticalStyles } from '@gs-ux-uitoolkit-common/style-ssr';
/**
 * Used for SSR (server-side rendering), renders a static JSX `<style>` tag with
 * all of the "critical styles" (i.e. the styles required by the HTML snippet)
 * for the server-side rendered page.
 *
 * This can be used for the Next.js "Pages Router" (but not the "App Router" -
 * for that, use {@link AppRouterStyleRegistry} instead).
 */
export function renderStyles(html, { nonce } = {}) {
    const { key, ids, css } = extractCriticalStyles(html);
    return (_jsx("style", { nonce: nonce, "data-emotion": `${key} ${ids.join(' ')}`, dangerouslySetInnerHTML: { __html: css } }));
}
//# sourceMappingURL=render-styles.js.map